export type UserReferralInfo = {
  referralCode: string;
  referralCount: number;
};

export const REFERRAL_LIFETIME_REWARD_COUNT = 3;
